import React from "react";
import { newMissionState } from "../../../atoms/core";
import { RecoilRoot } from "recoil";
import { MockedProvider } from "@apollo/client/testing";
import {
    FIND_CCT,
    GET_CCT_DETAILS_FIELDS,
    GET_CCT_BY_EDITION_BY,
    GET_CCT_DETAILS_FIELD_VALUES,
} from "../../../graphql/cct";
import CreateMissionCCT from "../../../screens/create-mission/CreateMissionCCT";
import { currentLang } from "../../../atoms/i18n";
import type { Meta, StoryObj } from "@storybook/react";
import { CCTS_FIELD_VALUES, CCTS_FIELDS, CCTS_WITH_LSE, CCTS_WITHOUT_LSE } from "../../factories";
import { Cct } from "../../../__generated__/graphql";
import MissionScreensManager from "../../../contexts/CreateMissionManager";

function StoryComponent({ ccts }: { ccts: Record<string, Cct> }) {
    const mocks = [
        {
            request: {
                query: GET_CCT_BY_EDITION_BY,
            },
            variableMatcher: () => true,
            newData: ({ cctEditionId }: { cctEditionId: string }) => ({
                data: {
                    getCctByEditionId: ccts[cctEditionId],
                },
            }),
        },
        {
            request: {
                query: FIND_CCT,
            },
            variableMatcher: () => true,
            newData: () => {
                return {
                    data: {
                        findCct: {
                            elements: Object.values(ccts),
                            pageInfo: {
                                totalElements: ccts.length,
                            },
                        },
                    },
                };
            },
        },
        {
            request: {
                query: GET_CCT_DETAILS_FIELDS,
            },
            variableMatcher: () => true,

            newData: ({ cctEditionId }: { cctEditionId: string }) => {
                return {
                    data: {
                        getCctDetailsFields: CCTS_FIELDS[cctEditionId],
                    },
                };
            },
        },
        {
            request: {
                query: GET_CCT_DETAILS_FIELD_VALUES,
            },
            variableMatcher: () => true,
            newData: ({
                cctEditionId,
                criteriaStructureId,
            }: {
                cctEditionId: string;
                criteriaStructureId: number;
            }) => {
                const key = `${cctEditionId}-${criteriaStructureId}`;
                return {
                    data: {
                        getCctDetailsFieldValues: CCTS_FIELD_VALUES[key],
                    },
                };
            },
        },
    ];

    return (
        <RecoilRoot
            initializeState={(snap) => {
                snap.set(currentLang, "fr");
                snap.set(newMissionState, {
                    id: "fake-id",
                    currentContract: {
                        contractEffectiveAsset: { id: "007" },
                        workingAddress: {
                            locality: {
                                state: {
                                    code: "VS",
                                },
                            },
                        },
                    },
                });
            }}
        >
            <MockedProvider mocks={mocks}>
                <MissionScreensManager
                    onValidate={() => {
                        alert("Screen Validated");
                    }}
                >
                    <CreateMissionCCT />
                </MissionScreensManager>
            </MockedProvider>
        </RecoilRoot>
    );
}

const meta = {
    title: "CreateMission/CCT",
    component: StoryComponent,
    argTypes: {},
} satisfies Meta<typeof StoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const WithLse: Story = {
    args: {
        ccts: CCTS_WITH_LSE,
    },
};
export const WithoutLse: Story = {
    args: {
        ccts: CCTS_WITHOUT_LSE,
    },
};
